if (!customElements.get("nss-product-card")) {
    customElements.define(
        "nss-product-card",
        class NSSProductCard extends HTMLElement {
            constructor() {
                super();

                this.selectors = {
                    video: ".js-nss-product-card-video",
                    form: ".js-nss-product-card-form",
                    addToCartButton: ".js-nss-product-card-add-to-cart",
                    quick_add: ".js-quick-shop",
                };
            }

            connectedCallback() {
                this.video = this.querySelector(this.selectors.video);

                if (this.video) {
                    this.initObserver();
                    this.initHover();
                }

                this.form = this.querySelector(this.selectors.form);
                this.addToCartButton = this.querySelector(this.selectors.addToCartButton);
                if (this.form) {
                    this.initAddedToCart();
                }

                this.quick_add = this.querySelector(this.selectors.quick_add);
                if (this.quick_add) {
                    this.quick_add.addEventListener("click", () => {

                    })
                }

            }


            initAddedToCart() {
                if (!this.form) return;
                this.form.addEventListener("submit", (e) => {
                    e.preventDefault();

                    let formData = new FormData(this.form);
                    this.addToCartButton?.classList.add("loading");
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        body: formData
                    })
                        .then(response => {
                            this.addToCartButton?.classList.remove("loading");
                            return response.json();
                        })
                        .catch((error) => {
                            this.addToCartButton?.classList.remove("loading");
                            console.error('Error:', error);
                        });
                });

            }

            initObserver() {
                if (!this.video) return;
                if (!("IntersectionObserver" in window)) return;

                this.observer = new IntersectionObserver(
                    entries => {
                        entries.forEach(entry => {
                            if (!entry.isIntersecting) return;

                            this.loadVideo();
                            this.observer.disconnect();
                        });
                    },
                    {
                        root: null,
                        rootMargin: "100px",
                        threshold: 0.25
                    }
                );

                this.observer.observe(this);
            }

            loadVideo() {

                if (this.video.dataset.loaded) return;

                this.video.dataset.loaded = "true";

                if (this.video.dataset.src) {
                    this.video.src = this.video.dataset.src;
                }

                this.video.load();
            }

            initHover() {
                if (!this.video) return;
                this.addEventListener("mouseenter", () => {
                    if (!this.video.dataset.loaded) return;

                    this.video.play().catch(() => {
                    });
                });

                this.addEventListener("mouseleave", () => {
                    this.video.pause();
                });
            }
        }
    );
}
